import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useParams,
} from 'react-router-dom'
import QrLandingPage from '@/pages/QrLandingPage'
import ProfileAccessPage from '@/pages/ProfileAccessPage'

// `businesscard.getconnexa.app` serves QR landings directly at the root —
// the dedicated vhost lets us drop the `/businesscard/` path prefix from
// printed QR codes. `app.getconnexa.app` keeps its legacy paths so old
// QR codes already in the wild continue resolving.
const isBusinessCardHost =
  typeof window !== 'undefined' &&
  window.location.hostname.startsWith('businesscard.')

// Backwards-compat for QR codes printed before the /c/ → /businesscard/ rename.
function LegacyQrRedirect() {
  const { token } = useParams<{ token: string }>()
  return <Navigate to={`/businesscard/${token}`} replace />
}

export default function App() {
  if (isBusinessCardHost) {
    return (
      <BrowserRouter>
        <Routes>
          {/* /profile/:accessToken is the post-exchange landing — declared
              before /:token so the two-segment path wins over the
              single-segment QR-token catch. */}
          <Route path="/profile/:accessToken" element={<ProfileAccessPage />} />
          <Route path="/:token" element={<QrLandingPage />} />
          <Route path="*" element={<Navigate to="/demo" replace />} />
        </Routes>
      </BrowserRouter>
    )
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/businesscard/:token" element={<QrLandingPage />} />
        <Route path="/c/:token" element={<LegacyQrRedirect />} />
        <Route path="/profile/:accessToken" element={<ProfileAccessPage />} />
        <Route path="*" element={<Navigate to="/businesscard/demo" replace />} />
      </Routes>
    </BrowserRouter>
  )
}
